'use client';
import { gql, useApolloClient, useQuery } from '@apollo/client';
import { useState } from 'react';
import { noop } from 'lodash';
import { FindContent, ListContent } from '../graphql/docs';
export const FETCH_POLICY = {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true
};
export const getDoc = (id) => (id ? FindContent : ListContent);
export const buildConfiguration = ({ id, name, filter = {}, limit = 100 }) => {
    if (id) {
        return {
            action: 'findContent',
            variables: { filter: { contextId: id }, type: name }
        };
    }
    return {
        action: 'listContent',
        variables: { filter: { name, ...filter }, limit }
    };
};
const contentResponse = (data, action, loading, error) => ({
    data: data ? data[action] : null,
    loading,
    error
});
export default function useContent({ id, name, filter = {}, limit = 100 }) {
    const doc = getDoc(id);
    const { action, variables } = buildConfiguration({ id, name, filter, limit });
    const { data, loading, error } = useQuery(gql(doc), {
        variables,
        ...FETCH_POLICY
    });
    return contentResponse(data, action, loading, error);
}
export const useGetContent = (onSuccess = noop, onError = noop) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const apollo = useApolloClient();
    const fetch = (doc, action, variables) => {
        apollo
            .query({
            query: gql(doc),
            variables,
            ...FETCH_POLICY
        })
            .then(({ data }) => {
            setData(data[action]);
            onSuccess(data[action]);
            setLoading(false);
        })
            .catch((e) => {
            setError(e);
            onError(e);
            setLoading;
        });
    };
    return ({ id, name, filter = {}, limit = 100 }) => {
        const doc = getDoc(id);
        const { action, variables } = buildConfiguration({ id, name, filter, limit });
        fetch(doc, action, variables);
        return contentResponse(data, action, loading, error);
    };
};
